// import Swiper JS
import Swiper, {Controller} from 'swiper';
import { playPauseVideo } from '../helpers/video';

Swiper.use([Controller]);


export const cardSlider = () => {


	const cardSliderModules = document.querySelectorAll('.m__cslider');
	cardSliderModules.forEach((cardSliderModule) => { //Loop through each card slider and initialise swiper and buttons
		let cardSliderSwiper = cardSliderModule.querySelector('.swiper');
		let thisCSwiper = new Swiper(cardSliderSwiper, {
			slidesPerView : 1,
			centeredSlides : false,
			rewind : false,
			loop : true,
			shortSwipes: false,
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			breakpoints: {
				1200: {
					slidesPerView: 3,
					spaceBetween: 44
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 34
				},
			}
		});

		let thisCSliderNextArrow = cardSliderModule.querySelector('.js__cslider__swiper-next');
		let thisCSliderPrevArrow = cardSliderModule.querySelector('.js__cslider__swiper-prev');

		let thisCSliderNumSlides = cardSliderModule.querySelectorAll('.m__cslider__swiper-slide').length;

		//Hide arrows if all slides are visible on this screen size
    	if(thisCSwiper.slidesPerViewDynamic() >= thisCSliderNumSlides){
    		thisCSliderNextArrow.classList.add('hidden');
    		thisCSliderPrevArrow.classList.add('hidden');
    	}

		//Move to next slide if 'next' arrow clicked
		if(thisCSliderNextArrow){
			thisCSliderNextArrow.addEventListener('click', (event) => {
				let nextSlideIndex = thisCSwiper.activeIndex + 1;
				thisCSwiper.slideNext();
			})
		}
		//Same as above but for going backwards/previous
		if(thisCSliderPrevArrow){
			thisCSliderPrevArrow.addEventListener('click', (event) => {
				let prevSlideIndex = thisCSwiper.activeIndex - 1;
				thisCSwiper.slidePrev();
			})
		}

		// //Hide arrows on first/last slide
		// thisCSwiper.on('reachEnd', function () {
		// 	thisCSliderNextArrow.classList.add('hidden');
		// });
		// thisCSwiper.on('reachBeginning', function () {
		// 	thisCSliderPrevArrow.classList.add('hidden');
		// });

		// //Show arrows on other slides
		// thisCSwiper.on('slideChange', function () {

		// 	if(thisCSwiper.activeIndex > (thisCSliderNumSlides - thisCSwiper.slidesPerViewDynamic() )){ //If not on the last slide
		// 		thisCSliderNextArrow.classList.add('hidden');
		// 	}else{
		// 		thisCSliderNextArrow.classList.remove('hidden');
		// 	}

		// 	if(thisCSwiper.activeIndex > 0){ //If not on the first
		// 		thisCSliderPrevArrow.classList.remove('hidden');
		// 	}else{
		// 		thisCSliderPrevArrow.classList.add('hidden');
		// 	}
		// });

		// window.addEventListener("resize", (e) => {
		// 	//Hide arrows if all slides are visible on this screen size
	    // 	if(thisCSwiper.slidesPerViewDynamic() > thisCSliderNumSlides){
	    // 		thisCSliderNextArrow.classList.add('hidden');
	    // 		thisCSliderPrevArrow.classList.add('hidden');
	    // 	}else{
	    // 		if(thisCSwiper.activeIndex < (thisCSliderNumSlides - thisCSwiper.slidesPerViewDynamic())){
	    // 			thisCSliderNextArrow.classList.remove('hidden');
	    // 		}
	    // 		if(thisCSwiper.activeIndex > 0){
	    // 			thisCSliderPrevArrow.classList.remove('hidden');
	    // 		}
	    // 	}
		// });


	});
	//Initialise the slider
}

